import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AttachmentPoint } from '../../models/attachmentpoint';
import { AttachmentPointService } from '../../services/attachment-point.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-attachmentpoints-delete',
  templateUrl: './attachmentpoints-delete.component.html',
  styleUrls: ['./attachmentpoints-delete.component.css']
})
export class AttachmentpointsDeleteComponent implements OnInit {
  attachmentPoint : AttachmentPoint;
  @Output() onDeleteValidation = new EventEmitter<boolean>();
  
  constructor(private apService : AttachmentPointService,
              public activeModal : NgbActiveModal,
              public toast : ToastsManager,
              public translate : TranslateService) { }

  ngOnInit() {
  }

  onDeleteClick() {
    this.apService.delete(this.attachmentPoint).subscribe(() => {
      this.activeModal.close("close");
      this.toast.success(this.translate.instant("toast.apdeleted"), this.translate.instant("toast.success"));
      this.onDeleteValidation.emit(true);
    });
    
  }

}



// WEBPACK FOOTER //
// ./src/app/attachmentpoints/attachmentpoints-delete/attachmentpoints-delete.component.ts